'use client'

import { FileText } from 'lucide-react'

import { PublicPolicyPage } from '../_components/public-policy-page'

export default function TermsConditionsPage() {
  return (
    <PublicPolicyPage
      activePage="termsConditions"
      contentKey="terms_of_services"
      emptyIcon={FileText}
      pageNamespace="public.termsConditions"
    />
  )
}
